var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4892 4.34104L16.7802 3.30004L18.7662 0.0400391L20.4752 1.08104L18.4892 4.34104ZM24.4722 6.36904L23.6502 4.54704L20.3192 6.05104L21.1412 7.87304L24.4722 6.36904ZM8.22523 3.30004L6.23923 0.0400391L4.53023 1.08104L6.51523 4.34104L8.22523 3.30004ZM4.68523 6.05104L1.35523 4.54704L0.532227 6.36904L3.86223 7.87304L4.68523 6.05104ZM8.50023 21V24H16.5002V21.063C16.5002 21.041 16.5062 21.021 16.5062 21H8.50023ZM7.25623 18.032C7.56423 18.3 7.80423 18.636 8.00323 19H11.5002V13.816C10.3392 13.402 9.50023 12.302 9.50023 11H11.5002C11.5002 11.552 11.9482 12 12.5002 12C13.0522 12 13.5002 11.552 13.5002 11H15.5002C15.5002 12.302 14.6612 13.402 13.5002 13.816V19H17.0222C17.2262 18.623 17.4692 18.275 17.7822 17.999C19.5102 16.481 20.5002 14.295 20.5002 12C20.5002 9.83904 19.6512 7.81304 18.1102 6.29704C16.5692 4.78104 14.5142 3.95904 12.3642 4.00104C8.18023 4.07004 4.65523 7.52704 4.50623 11.706C4.41823 14.134 5.42023 16.439 7.25623 18.032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.73ab81f6cfd5360deb6975321b5d5d51.svg";
export { ForwardRef as ReactComponent };